import styled from '@emotion/styled';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 900px;
  max-height: 80vh;
`;

export const Header = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 10px 0;
`;

export const CenteredH2 = styled.h2`
  flex-grow: 1;
  text-align: center;
`;

export const ScrollableContent = styled.div`
  overflow-y: auto;
  max-height: 60vh;
  padding-top: 10px;
`;

export const GeneralDocumentPickerItem = styled.div`
  display: flex;
  padding: 10px;
  margin-bottom: 5px;
  border-radius: 5px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }
`;

export const ModalActionContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: 10px;
`;
